import React from 'react';

import AudioPreview from 'assets/icons/colored/audio-preview.svg';
import HTMLPreview from 'assets/icons/colored/html-preview.svg';
import PdfPreview from 'assets/icons/colored/pdf-preview.svg';
import TxtPreview from 'assets/icons/colored/txt-preview.svg';
import VideoPreview from 'assets/icons/colored/video-preview.svg';
import cn from 'classnames';

import bem from 'client/services/bem';

import {MEDIA_MIME_TYPES} from 'client/common/config';
import Player from 'client/common/media-player';

import {MediaContainerProps} from './types';

import cssModule from './media-container.module.scss';

const b = bem('media-container', {cssModule});

const componentPreviewMap = {
  [MEDIA_MIME_TYPES.mp4]: VideoPreview,
  [MEDIA_MIME_TYPES.mp3]: AudioPreview,
  [MEDIA_MIME_TYPES.pdf]: PdfPreview,
  [MEDIA_MIME_TYPES.html]: HTMLPreview,
  [MEDIA_MIME_TYPES.txt]: TxtPreview,
};

const MediaContainer: React.FC<MediaContainerProps> = (props) => {
  const {
    sources,
    width = 0,
    height = 0,
    keepRatio = true,
    imageStyle,
    label = '',
    className = '',
    testId,
    isMediaPreview = true,
    placeholderIcon,
    onLoadStart,
  } = props;

  if (!sources.length) {
    return (
      <div className={cn(b(), className)} data-testid={testId}>
        {placeholderIcon && <img src={placeholderIcon} alt="" />}
      </div>
    );
  }

  const previewSrc = String(componentPreviewMap[sources[0].type]);
  const isHTML = MEDIA_MIME_TYPES.html === sources[0].type;
  const isTxt = MEDIA_MIME_TYPES.txt === sources[0].type;
  const shouldDisplayPreview = isMediaPreview || isHTML || isTxt;

  return (
    <div className={cn(b({preview: shouldDisplayPreview}), className)} data-testid={testId}>
      {label && <span className={b('label')}>{label}</span>}
      {shouldDisplayPreview ? (
        <img src={previewSrc} alt="" />
      ) : (
        <Player
          mediaType={sources[0].type}
          sources={sources}
          width={width}
          height={height}
          keepRatio={keepRatio}
          style={imageStyle}
          onLoadStart={onLoadStart}
        />
      )}
    </div>
  );
};

export default MediaContainer;
